import type { AIProvider } from '@/types';
import { HeuristicProvider } from './heuristicProvider';
import { ClaudeVisionProvider } from './claudeProvider';

export { HeuristicProvider, heuristicDirective } from './heuristicProvider';
export { ClaudeVisionProvider } from './claudeProvider';
export { DESIGN_DIRECTIVE_SCHEMA } from './schema';

export const heuristicProvider = new HeuristicProvider();
export const claudeProvider = new ClaudeVisionProvider();

/**
 * Provider selection is a runtime decision, not a build-time one: the app
 * always ships with a working engine and upgrades itself if the proxy reports
 * a configured API key.
 */
export function selectProvider(preferAI: boolean): AIProvider {
  if (preferAI && claudeProvider.available()) return claudeProvider;
  return heuristicProvider;
}
